import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { stringify } from 'querystring';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AppComponent } from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
import { Insertnoticecase } from '../generate-notice/insertnoticecase';


export class FinalVerdict {
  
 
  refno: any;
  CourtID: any;
  FillingParty:any;
  OppositeParty:any;
  StateID: any;
  Type:string;
  CityID: any;
  CategoryID: any;
  SubCategoryID: any;
  Decision:any;
  Amount:number;
  FinalVerdictFromTime:string;
  FinalVerdictToTime:string;
  FinalVerdictAlertFromTime:string;
  FinalVerdictAlertToTime:string;
  HeaderRemarks:string;
  JudgeMentImplications:string;
  JudgeMentImplication=[];
  ManagementDecisionOption=[];
  NoticeId: string;
  Mode:string;
  recAddUser: Int16Array;
  contextID: Int16Array;
 fileSize: string;
  fileBase = [];
  fileName: string;
    //PaymentOfPenality
      PaymentAmount:number;
      PaymentFromTime:string;
      PaymentToTime:string;
      PaymentResponsiblePerson:string;
      Paymenttomadeinfavourof:string;
      PaymentRemarks:string;
    //END

    //RecoveryOfAmount
    RecoverAmount:number;
    RecoveryFromTime:string;
    RecoveryToTime:string;
    RecoveryResponsiblePerson:string;
    RecoveryRemarks:string;
  //END

  //Compliance
  TypeofCompliance:string;
  ComplianceFromTime:string;
  ComplianceToTime:string;
  ComplianceResponsiblePerson:string;
  ComplianceRemarks:string;
  //END

}

@Component({
    selector: 'app-Final-Verdict',
    templateUrl: './Final-Verdict.component.html',
    styleUrls: ['./Final-Verdict.component.css'],
    standalone: false
})


export class FinalVerdictComponent implements OnInit {
 
  pageHeader: string;
  buttonname: string;
  url: string;
  ManagementDecision: string;
  JudgementsImplicationed:string;
  MD :string;
  MDFinal= [];
  dropdownList = [];
  selectedItems = [];

  CheckMangerDecision= [];
  dropdownSettings:any={};
  dropdownSettingsJudgements:any={};
  dropdownListJudgements= [];
  SelectedItemsJudgement = [];
  
  TypeHeader: string;
  City: any;
  pageurl: string;
  id: string;
  State: any;
  addFormFinalVedict: FormGroup;
  Category: any;
  SubCategory: any;

  CaseID: string;
  fetchNoticeCase: any;
   RequestFrom: string;
   RequestFromUploadFile:string
   PaymentofPenaltyRequestFrom:string;
   RecoveryofAmountRequestFrom:string;
   ComplianceofComplyRequestFrom:string;
   PaymentofPenaltySelecteditem:string;
   AppealtoHigherAuthoritySelecteditem:string;
   NoFurtherActionRequiredSelecteditem:string;
   ComplywithComplianceSelecteditem:string;
   RecoveryofAmountSelecteditem:string;

   AppealtoHigherAuthority:string;

  DetPageDetails: string;
  RefNo: any;
  CaptionJurisdiction: any;
  Jurisdiction: any;
  PageheadMain: string;
  FetchExistingFillingParty: any;
  FetchExistingOppositeParty:any;
  Msg: string;
  loading: boolean;
  numb: any;
  factsheetDetail: any;
  modalURL: string;
  DownloadURL: string;
  buttonSubmitFinalVerdict:string;
  fileurls = [];
  dtColumns = [];
  fileBase = [];
  fileSize: string;
  fileName: string;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2090, 0, 1);
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  Mode: string;
  NOFUTHERAUCTION: string;
  PaymentResponsiblePerson: any;
  RecoveryResponsiblePerson: any;
  ComplianceResponsiblePerson: any;
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, protected alertService: AlertService )
   {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
  }


  ngOnInit() {
    this.pageHeader = 'Final Verdict';

    this.DetPageDetails ='';
    this.buttonSubmitFinalVerdict="1";
    this.RequestFrom ="0";
   // this.buttonname = 'Submit'
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.id = pagehead[2];
    this.Mode= pagehead[3];

   this.Fetchfinalverdictdata();
   this.FetchExistingFillingDetail();
   this.FetchExistingOppositeDetail();
   this.RequestFromUploadFile="0";
   this.PaymentofPenaltyRequestFrom="0";
  

    if (pagehead[2]="FinalVerdict")
    {
      this.PageheadMain="Case";
    }

  
   this.getMaster('010', '').subscribe((data: any) => {
      this.State = data;
      this.Jurisdiction = data;
    });
    this.getMaster('020', '').subscribe((data: any) => {
      this.City = data;
    });

    this.getMaster('130', '').subscribe((data: any) => {
      
      this.ManagementDecision=data;
      
      this.dropdownList = data;
    
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'MainDescr',
        textField: 'MainDescr',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 10,
        allowSearchFilter: true
      };

      //Judgement 

      this.dropdownListJudgements = data;

      this.dropdownSettingsJudgements = {
        singleSelection: false,
        idField: 'MainDescr',
        textField: 'MainDescr',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 10,
        allowSearchFilter: true
      };
      //END
    
    });
    this.buttonSubmitFinalVerdict="1";
    if(this.Mode.toString()=="2")
    {
   
     this.buttonSubmitFinalVerdict="2";
     this.FetchedJudgementDescions();
    }

   
    this.FetchFinalVerdictManagementDescion();
    this.FetchfinalverdictdataUpdateMST();
    this.FetchFinalVerdictattachement();
    this.FetchedManagementDescions();
    
    this.BindUserMaster();

    this.FetchFinalVerdictJudgementDescion();
    this.getMaster('045', '').subscribe((data: any) => {
      this.Category = data;
    });

    this.getMaster('050', '').subscribe((data: any) => {
      this.SubCategory = data;
    });



    //Start
    this.addFormFinalVedict = this.formBuilder.group({

      /* BASIC DETAILS */
      refno: [{ value: '', disabled: true }],
      Jurisdiction: [null, Validators.required],
      State: [null, Validators.required],
      City: [null, Validators.required],
      Category: [null, Validators.required],
      SubCategory: [null, Validators.required],

      /* FILE & DECISION */
      browseFiles: [null, Validators.required],
      Amount: [null, Validators.required],
      Decision: [null, Validators.required],
      JudgementsImplications: [null, Validators.required],
      Remarks: [''],

      /* DATE RANGE – FINAL VERDICT */
      DateofFinalvedictFromTime: [null, Validators.required],
      DateofFinalvedictToTime: [null, Validators.required],

      /* MANAGEMENT */
      ManagementDecision: [null],

      /* PAYMENT OF PENALTY */
      PaymentAmount: [null],
      PaymentResponsiblePerson: [null],
      Paymenttomadeinfavourof: [''],
      PaymentRemarks: [''],
      DateofFinalVedictPaymentFromTime: [null],
      DateofFinalVedictPaymentToTime: [null],

      /* RECOVERY */
      RecoverAmount: [null],
      RecoveryResponsiblePerson: [null],
      RecoveryRemarks: [''],
      DateofFinalVedictRecoveryFromTime: [null],
      DateofFinalVedictRecoveryToTime: [null],

      /* COMPLIANCE */
      TypeofCompliance: [''],
      ComplianceResponsiblePerson: [null],
      ComplianceRemarks: [''],
      DateofFinalVedictComplianceFromTime: [null],
      DateofFinalVedictComplianceToTime: [null]

    });
    //END 
    
//Start
    this.addFormFinalVedict.patchValue({
      State: 0 ,  City: 0,Amount:0,

    });
    //END

    //Start Caption
    this.http.get(this.url + 'Dashboard/CaptionData?id=')
    .subscribe( (data) =>   {
      
      for (var val of JSON.parse(data.toString())) {
      
        if (val['MainDescr'] == this.PageheadMain && val['SubDescr']=='Jurisdiction/ Court Name') {
          this.CaptionJurisdiction=val['SelectedValue']; }
         if (val['MainDescr'] == this.PageheadMain && val['SubDescr']=='Ref No. *') {
              this.RefNo=val['SelectedValue'].replace("*", ''); }
              if (val['MainDescr'] == this.PageheadMain && val['SubDescr']=='Ref No. *') {
                this.RefNo=val['SelectedValue'] }
     
        }
      })

    //END

      this.applyConditionalValidators();

      this.addFormFinalVedict.get('ManagementDecision').valueChanges.subscribe(value => {
        if (value.length == 0) {
          this.resetAllFlags();
        }
      })

  }

  private applyConditionalValidators(): void {

    /* PAYMENT OF PENALTY */
    if (this.PaymentofPenaltyRequestFrom === '1') {
      this.setRequired([
        'PaymentAmount',
        'PaymentResponsiblePerson',
        'Paymenttomadeinfavourof',
        'PaymentRemarks',
        'DateofFinalVedictPaymentFromTime',
        'DateofFinalVedictPaymentToTime'
      ]);
    } else {
      this.clearValidators([
        'PaymentAmount',
        'PaymentResponsiblePerson',
        'Paymenttomadeinfavourof',
        'PaymentRemarks',
        'DateofFinalVedictPaymentFromTime',
        'DateofFinalVedictPaymentToTime'
      ]);
    }

    /* RECOVERY OF AMOUNT */
    if (this.RecoveryofAmountRequestFrom === '2') {
      this.setRequired([
        'RecoverAmount',
        'RecoveryResponsiblePerson',
        'RecoveryRemarks',
        'DateofFinalVedictRecoveryFromTime',
        'DateofFinalVedictRecoveryToTime'
      ]);
    } else {
      this.clearValidators([
        'RecoverAmount',
        'RecoveryResponsiblePerson',
        'RecoveryRemarks',
        'DateofFinalVedictRecoveryFromTime',
        'DateofFinalVedictRecoveryToTime'
      ]);
    }

    /* COMPLIANCE */
    if (this.ComplianceofComplyRequestFrom === '3') {
      this.setRequired([
        'TypeofCompliance',
        'ComplianceResponsiblePerson',
        'ComplianceRemarks',
        'DateofFinalVedictComplianceFromTime',
        'DateofFinalVedictComplianceToTime'
      ]);
    } else {
      this.clearValidators([
        'TypeofCompliance',
        'ComplianceResponsiblePerson',
        'ComplianceRemarks',
        'DateofFinalVedictComplianceFromTime',
        'DateofFinalVedictComplianceToTime'
      ]);
    }

  }
  private setRequired(controls: string[]) {
    controls.forEach(control => {
      this.addFormFinalVedict
        .get(control)
        ?.setValidators(Validators.required);
      this.addFormFinalVedict
        .get(control)
        ?.updateValueAndValidity();
    });
  }

  private clearValidators(controls: string[]) {
    controls.forEach(control => {
      this.addFormFinalVedict
        .get(control)
        ?.clearValidators();
      this.addFormFinalVedict
        .get(control)
        ?.updateValueAndValidity();
    });
  }

  get f() { return this.addFormFinalVedict.controls; }

  onSelectFile(event) {
    this.fileurls = [];
    this.fileName = '';
    this.fileSize = '';
    if (event.target.files && event.target.files[0]) {
        var filesAmount = event.target.files.length;
        for (let i = 0; i < filesAmount; i++) {
          this.fileName += event.target.files[i].name + ',';
          this.fileSize += event.target.files[i].size + ',';
          let reader = new FileReader();
          reader.onload = ( event: any) => { this.fileurls.push(event.target.result); };
          reader.readAsDataURL(event.target.files[i]);
        }
    }
  }




  onFinalVerdictSubmit(FinalVerdictData) {
    if (this.addFormFinalVedict.invalid) {
      this.addFormFinalVedict.markAllAsTouched();
      return;
    }
    if (FinalVerdictData.Decision == "" || FinalVerdictData.Decision == null) {
      this.alertService.showWarning("Please Select Decision");
      return;
    }
   
      if (this.addFormFinalVedict.invalid) { return; }
      this.numb = 1;
      this.loading= true;
      this.Msg = "";
      let FinalVerdictSave: FinalVerdict = {
      
      refno:FinalVerdictData.refno,
      Mode:this.Mode,
      CourtID:"",
      FillingParty:"",
      Type:"C",
      OppositeParty:"",
      StateID:FinalVerdictData.State,
      CityID: FinalVerdictData.City,
      CategoryID: FinalVerdictData.Category,
      SubCategoryID: FinalVerdictData.SubCategory,
      Decision:FinalVerdictData.Decision,
      Amount:FinalVerdictData.Amount,
      FinalVerdictFromTime:FinalVerdictData.DateofFinalvedictFromTime,
      FinalVerdictToTime:FinalVerdictData.DateofFinalvedictToTime,
      FinalVerdictAlertFromTime:FinalVerdictData.DateofFinalVedictAlertFromTime,
      FinalVerdictAlertToTime:FinalVerdictData.DateofFinalVedictAlertToTime,
      HeaderRemarks:FinalVerdictData.Remarks,
      JudgeMentImplications:"",
      JudgeMentImplication:FinalVerdictData.JudgementsImplications,
      ManagementDecisionOption:FinalVerdictData.ManagementDecisionOption,

      fileSize: this.fileSize,
      fileBase: this.fileurls,
      fileName: this.fileName,

       //PaymentOfPenality
      PaymentAmount:FinalVerdictData.PaymentAmount,
      PaymentFromTime:FinalVerdictData.DateofFinalVedictPaymentFromTime,
      PaymentToTime:FinalVerdictData.DateofFinalVedictPaymentToTime,
      PaymentResponsiblePerson:FinalVerdictData.PaymentResponsiblePerson,
      Paymenttomadeinfavourof:FinalVerdictData.Paymenttomadeinfavourof,
      PaymentRemarks:FinalVerdictData.PaymentRemarks,
    //END

    //RecoveryOfAmount
    RecoverAmount:FinalVerdictData.RecoverAmount,
    RecoveryFromTime:FinalVerdictData.DateofFinalVedictRecoveryFromTime,
    RecoveryToTime:FinalVerdictData.DateofFinalVedictRecoveryToTime,
    RecoveryResponsiblePerson:FinalVerdictData.RecoveryResponsiblePerson,
    RecoveryRemarks:FinalVerdictData.RecoveryRemarks,
  //END

  //Compliance
  TypeofCompliance:FinalVerdictData.TypeofCompliance,
  ComplianceFromTime:FinalVerdictData.DateofFinalVedictComplianceFromTime,
  ComplianceToTime:FinalVerdictData.DateofFinalVedictComplianceToTime,
  ComplianceResponsiblePerson:FinalVerdictData.ComplianceResponsiblePerson,
  ComplianceRemarks:FinalVerdictData.ComplianceRemarks,
  //END


      NoticeId: this.id,
      recAddUser: this.numb,
      contextID: this.numb,

       
      };
      this.http.post(this.url + 'Notice/InsertFinalVerdictCase', FinalVerdictSave) .subscribe( (data) => {
        this.Msg = "";
        this.loading= false;
      
             if (data == null) {
              this.alertService.showError("Final Verdict Not Submitted");
             } 
             else { 
              this.alertService.showSuccess("Final Verdict Submit Successfully");
                 if(this.Mode.toString()=="1")
                 {
                  window.history.back();
                 }
                 else
                 {
                  window.close();
                 }
                   
                
            }
            },(error) => {
              this.Msg = "";
              this.loading= false;
              this.alertService.showError("Final Verdict Not Submitted");
            }
          );
  
 
  }

 

   onManagerDecisionSelect(MangerValue : any) {

    if(MangerValue.toString().toUpperCase()=="PAYMENT OF PENALTY")
    {
      
      this.PaymentofPenaltyRequestFrom="1";
      this.DetPageDetails="Payment of Penalty";
      this.PaymentofPenaltySelecteditem= MangerValue ;
      this.selectedItems = [this.PaymentofPenaltySelecteditem];
     
    }

    if(MangerValue.toString().toUpperCase()=="RECOVERY OF AMOUNT")
    {
      this.RecoveryofAmountRequestFrom="2";
      this.DetPageDetails="Recovery of Amount";
      this.RecoveryofAmountSelecteditem= MangerValue ;
      this.selectedItems = [this.RecoveryofAmountSelecteditem];
    }

    if(MangerValue.toString().toUpperCase()=="COMPLY WITH COMPLIANCE")
    {
     
      this.ComplianceofComplyRequestFrom="3";
      this.DetPageDetails="Comply with Compliances";
     // this.selectedItems = [MangerValue];

      //this.ComplywithComplianceSelecteditem= [this.selectedItems] +"," + MangerValue;
      this.ComplywithComplianceSelecteditem= [this.selectedItems] +"," + MangerValue;
      this.selectedItems = [this.ComplywithComplianceSelecteditem];
     
      
    }

    if(MangerValue.toString().toUpperCase()=="NO FURTHER ACTION REQUIRED")
    {
     
      this.ComplianceofComplyRequestFrom="0";
      this.RecoveryofAmountRequestFrom="0";
      this.PaymentofPenaltyRequestFrom="0";
      this.DetPageDetails="No Further Action Required";
      this.NOFUTHERAUCTION="No Further Action Required";
      this.selectedItems = [this.NOFUTHERAUCTION];
      
      //this.selectedItems = [MangerValue];
      
    }

    if(MangerValue.toString().toUpperCase()=="APPEAL TO HIGHER AUTHORITY")
    {
    
      this.ComplianceofComplyRequestFrom="0";
      this.RecoveryofAmountRequestFrom="0";
      this.PaymentofPenaltyRequestFrom="0";
      this.DetPageDetails="Appeal to Higher Authority";
      this.AppealtoHigherAuthority="APPEAL TO HIGHER AUTHORITY";
      this.selectedItems = [this.AppealtoHigherAuthority];
     
    }
   
  }

  onManagerDecisionSelectJudgements(selectedItems : any) {
    this.SelectedItemsJudgement = [];
  selectedItems.forEach(item => {
    let MangerValue = item.MainDescr;
    if(MangerValue.toString().toUpperCase()=="PAYMENT OF PENALTY")
    {
      this.PaymentofPenaltySelecteditem=   MangerValue;
      this.SelectedItemsJudgement.push(this.PaymentofPenaltySelecteditem);
     
    }

    if(MangerValue.toString().toUpperCase()=="RECOVERY OF AMOUNT")
    {
    
      this.RecoveryofAmountSelecteditem=  MangerValue;
      this.SelectedItemsJudgement.push(this.RecoveryofAmountSelecteditem);
    }

    if(MangerValue.toString().toUpperCase()=="COMPLY WITH COMPLIANCE")
    {
     
     
      this.ComplywithComplianceSelecteditem= [this.SelectedItemsJudgement].toString();
      this.SelectedItemsJudgement.push(this.ComplywithComplianceSelecteditem);
     
      
    }

    if(MangerValue.toString().toUpperCase()=="NO FURTHER ACTION REQUIRED")
    {
     
      
      this.NOFUTHERAUCTION="No Further Action Required";
      this.SelectedItemsJudgement.push(this.NOFUTHERAUCTION);
      
    }

    if(MangerValue.toString().toUpperCase()=="APPEAL TO HIGHER AUTHORITY")
    {
    
     
      this.AppealtoHigherAuthority="APPEAL TO HIGHER AUTHORITY";
      this.SelectedItemsJudgement.push(this.AppealtoHigherAuthority);
     
    }
  })
   
  }



  

  // onManagerDecisionDeSelect(MangerValue : any) {

   
  //   if(MangerValue.toString().toUpperCase()=="PAYMENT OF PENALTY")
  //   {
      
  //     this.PaymentofPenaltyRequestFrom="0";
  //     this.DetPageDetails="Payment of Penalty";
   

      
  //   }

  //   if(MangerValue.toString().toUpperCase()=="RECOVERY OF AMOUNT")
  //   {
  //     this.RecoveryofAmountRequestFrom="0";
  //     this.DetPageDetails="Recovery of Amount";
  //   }

  //   if(MangerValue.toString().toUpperCase()=="COMPLY WITH COMPLIANCE")
  //   {
     
  //     this.ComplianceofComplyRequestFrom="0";
  //     this.DetPageDetails="Comply with Compliances";
  //   }
  // }

  
  onManagerDecisionAdd(item: any) {
    const value = item?.MainDescr?.toString().toUpperCase();

    switch (value) {

      case 'PAYMENT OF PENALTY':
        this.PaymentofPenaltyRequestFrom = '1';
        this.DetPageDetails = 'Payment of Penalty';
        this.selectedItems = [item];
        break;

      case 'RECOVERY OF AMOUNT':
        this.RecoveryofAmountRequestFrom = '2';
        this.DetPageDetails = 'Recovery of Amount';
        this.selectedItems = [item];
        break;

      case 'COMPLY WITH COMPLIANCE':
        this.ComplianceofComplyRequestFrom = '3';
        this.DetPageDetails = 'Comply with Compliances';
        this.selectedItems = [item];
        break;

      case 'NO FURTHER ACTION REQUIRED':
        // this.resetAllFlags();
        this.DetPageDetails = 'No Further Action Required';
        this.selectedItems = [item];
        break;

      case 'APPEAL TO HIGHER AUTHORITY':
        // this.resetAllFlags();
        this.DetPageDetails = 'Appeal to Higher Authority';
        this.selectedItems = [item];
        break;
    }
  }
  onManagerDecisionRemove(item: any) {
    const value = item?.toString().toUpperCase();

    switch (value) {

      case 'PAYMENT OF PENALTY':
        this.PaymentofPenaltyRequestFrom = '0';
        // this.DetPageDetails = '';
        break;

      case 'RECOVERY OF AMOUNT':
        this.RecoveryofAmountRequestFrom = '0';
        // this.DetPageDetails = '';
        break;

      case 'COMPLY WITH COMPLIANCE':
        this.ComplianceofComplyRequestFrom = '0';
        // this.DetPageDetails = '';
        break;
    }
  }
  resetAllFlags() {
    this.PaymentofPenaltyRequestFrom = '0';
    this.RecoveryofAmountRequestFrom = '0';
    this.ComplianceofComplyRequestFrom = '0';
  }


   onStateSelect(value) {
    this.getMaster('015', value.hdID).subscribe( (data: any) => {
      this.City = data ;
      let data1: any;
      this.Jurisdiction = data1;
      this.addFormFinalVedict.patchValue({City: '0', Jurisdiction: '0'}); } );
  }
  onCitySelect(value) {
    this.getMaster('020', value.hdID).subscribe( (data: any) => {
      this.Jurisdiction = data;
      this.addFormFinalVedict.patchValue({Jurisdiction: '0'}); } );
  }
  onCategorySelect(value) {
  this.getMaster('050', value.hdID) .subscribe( (data: any) => {
      this.SubCategory = data;
      this.addFormFinalVedict.patchValue({ SubCategory: '0' });
        this.applyConditionalValidators();
    });
  }


  getMaster(GID: string, MID: string) {

    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
      .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
  }
  
  FetchExistingOppositeDetail() {
    this.http.get(this.url + 'Notice/FetchOppositePartyDetail?NoticeID=' + this.id)
        .subscribe( (data) =>   {
            if (data == null) {
              this.FetchExistingOppositeParty = null;
            } else {
              this.FetchExistingOppositeParty = JSON.parse(data.toString());
            }
           }
        );
  }
  FetchExistingFillingDetail() {
    this.http.get(this.url + 'Notice/FetchFillingPartyDetail?NoticeID=' + this.id)
        .subscribe( (data) =>   {
            if (data == null) {
              this.FetchExistingFillingParty = null;
            } 
            else {
                  this.FetchExistingFillingParty = JSON.parse(data.toString());
             
            }
           }
        );
  }

  Fetchfinalverdictdata() {

    this.http.get(this.url + 'Notice/FetchExistingNotice?ID=' + this.id)
      .subscribe((data) => {

        if (data == null) {
        } else {

          const fetchHeaderdataFinalVedict: FinalVerdict = JSON.parse(data.toString())[0];
          if (fetchHeaderdataFinalVedict.StateID != null) 
          {
            this.getMaster('015', fetchHeaderdataFinalVedict.StateID.toString()).subscribe( (data: any) => { this.City = data ; });
         }
         if (fetchHeaderdataFinalVedict.CityID != null) {
          this.getMaster('020', fetchHeaderdataFinalVedict.CityID.toString()).subscribe( (data: any) => { this.Jurisdiction = data; }); }

          
          if (fetchHeaderdataFinalVedict.CategoryID != null) {
            this.getMaster('050', fetchHeaderdataFinalVedict.CategoryID.toString()) .subscribe( (data: any) => { this.SubCategory = data; }); }

          this.addFormFinalVedict.patchValue({
           
           
            refno: fetchHeaderdataFinalVedict.refno,
            Jurisdiction: fetchHeaderdataFinalVedict.CourtID == null ? 0 : fetchHeaderdataFinalVedict.CourtID,
            City: fetchHeaderdataFinalVedict.CityID == null ? 0 : fetchHeaderdataFinalVedict.CityID,
            State: fetchHeaderdataFinalVedict.StateID == null ? 0 : fetchHeaderdataFinalVedict.StateID,
            Category: fetchHeaderdataFinalVedict.CategoryID == null ? 0 : fetchHeaderdataFinalVedict.CategoryID,
              SubCategory: fetchHeaderdataFinalVedict.SubCategoryID == null ? 0 : fetchHeaderdataFinalVedict.SubCategoryID,
             
          }
          
          
          )
          
          ;

        }
      }
      );
  }

  FetchFinalVerdictattachement() {
    this.http.get(this.url + 'Notice/FetchFinalVerdictattachement?NoticeID=' + this.id + '&Type=0')
    .subscribe( (data) =>   {
        if (data == null) 
        {
         
          this.factsheetDetail = null;
        } 
        else 
        {
          
          this.RequestFromUploadFile="7";
          this.factsheetDetail = JSON.parse(data.toString()); this.modalURL = '/';
        }
       }
    );
  }


  BindUserMaster() {
    this.http.get(this.url + 'Notice/UserMaster')
    .subscribe( (data) =>   {
        if (data == null) 
        {
         
          this.PaymentResponsiblePerson = null;
          this.RecoveryResponsiblePerson=null;
          this.ComplianceResponsiblePerson=null;
        } 
        else 
        {
          
        
          this.PaymentResponsiblePerson = JSON.parse(data.toString()); this.modalURL = '/';
          this.RecoveryResponsiblePerson = JSON.parse(data.toString()); this.modalURL = '/';
          this.ComplianceResponsiblePerson=JSON.parse(data.toString()); this.modalURL = '/';
        }
       }
    );
  }
  




  FetchFinalVerdictManagementDescion() {
    this.http.get(this.url + 'Notice/FetchFinalManagementDescions?NoticeID=' + this.id + '')
    .subscribe((data: any) =>   {
        if (data == null) {
          this.selectedItems = null;
        } else {
          
          this.selectedItems = data;
          
        }
       }
    );
  }


  FetchFinalVerdictJudgementDescion() {
    
    this.http.get(this.url + 'Notice/FetchFinalVerdictJudgementDecision?NoticeID=' + this.id + '')
    .subscribe((data: any) =>   {
        if (data == null) {
          this.SelectedItemsJudgement = null;
        } else {
          
          this.SelectedItemsJudgement = data;
          
        }
       }
    );
  }


  FetchedManagementDescions() {
    this.http.get(this.url + 'Notice/FetchedManagementDescions?NoticeID=' + this.id + '')
    .subscribe((data: any) =>   {
        if (data == null) {
          
        } else
         {
         
       
          data = data.toString().split(':');
        
                 this.JudgementsImplicationed = data[1].toString().split('}');
                 this.MD = this.JudgementsImplicationed[0].toString().replace(/^["'](.+(?=["']$))["']$/, '$1');;
            this.MDFinal=this.MD.toString().split(',');
                 
                 for (let i = 0; i < this.MDFinal.length; i++) 
                 {
                  this.CheckMangerDecision =this.MDFinal[i].toString();
                 
                  this.onManagerDecisionSelect(this.CheckMangerDecision)
                  
              }

        }
       }
    );
  }





  FetchedJudgementDescions() {
  
    this.http.get(this.url + 'Notice/FetchedJudgementDecision?NoticeID=' + this.id + '')
    .subscribe((data: any) =>   {
        if (data == null) {
          
        } else
         {
         
       
          data = data.toString().split(':');
        
                 this.JudgementsImplicationed = data[1].toString().split('}');
                 this.MD = this.JudgementsImplicationed[0].toString().replace(/^["'](.+(?=["']$))["']$/, '$1');;
            this.MDFinal=this.MD.toString().split(',');
                 
                 for (let i = 0; i < this.MDFinal.length; i++) 
                 {
                  this.CheckMangerDecision =this.MDFinal[i].toString();
                  
                  this.onManagerDecisionSelectJudgements(this.CheckMangerDecision)
                  
              }

        }
       }
    );
  }
  


  FetchfinalverdictdataUpdateMST() {

    this.http.get(this.url + 'Notice/FetchFinalVerdictDataUpdateMST?ID=' + this.id)
      .subscribe((data) => {

        if (data == null)
       {
        } 
        else 
        {
          const fetchHeaderdataFinalVedict: FinalVerdict = JSON.parse(data.toString())[0];
         
         
         
      
           this.addFormFinalVedict.patchValue({
            Decision: fetchHeaderdataFinalVedict.Decision == null ? 0 : fetchHeaderdataFinalVedict.Decision,
            Amount: fetchHeaderdataFinalVedict.Amount == null ? 0 : fetchHeaderdataFinalVedict.Amount,
            ManagementDecision: fetchHeaderdataFinalVedict.ManagementDecisionOption == null ? 0 : fetchHeaderdataFinalVedict.ManagementDecisionOption,
            JudgeMentImplication: fetchHeaderdataFinalVedict.JudgeMentImplications == null ? 0 : fetchHeaderdataFinalVedict.JudgeMentImplications,
            Remarks: fetchHeaderdataFinalVedict.HeaderRemarks == null ? 0 : fetchHeaderdataFinalVedict.HeaderRemarks,
            DateofFinalvedictFromTime: fetchHeaderdataFinalVedict.FinalVerdictFromTime == null ? 0 : fetchHeaderdataFinalVedict.FinalVerdictFromTime,
            DateofFinalvedictToTime: fetchHeaderdataFinalVedict.FinalVerdictToTime == null ? 0 : fetchHeaderdataFinalVedict.FinalVerdictToTime,
            DateofFinalVedictAlertFromTime: fetchHeaderdataFinalVedict.FinalVerdictAlertFromTime == null ? 0 : fetchHeaderdataFinalVedict.FinalVerdictAlertFromTime,
            DateofFinalVedictAlertToTime: fetchHeaderdataFinalVedict.FinalVerdictAlertToTime == null ? 0 : fetchHeaderdataFinalVedict.FinalVerdictAlertToTime,
             //PAYMENT

             PaymentAmount: fetchHeaderdataFinalVedict.PaymentAmount == null ? 0 : fetchHeaderdataFinalVedict.PaymentAmount,
             PaymentResponsiblePerson: fetchHeaderdataFinalVedict.PaymentResponsiblePerson == null ? 0 : fetchHeaderdataFinalVedict.PaymentResponsiblePerson,
             Paymenttomadeinfavourof: fetchHeaderdataFinalVedict.Paymenttomadeinfavourof == null ? 0 : fetchHeaderdataFinalVedict.Paymenttomadeinfavourof,
             PaymentRemarks: fetchHeaderdataFinalVedict.PaymentRemarks == null ? 0 : fetchHeaderdataFinalVedict.PaymentRemarks,
             DateofFinalVedictPaymentFromTime:fetchHeaderdataFinalVedict.PaymentFromTime == null ? 0 : fetchHeaderdataFinalVedict.PaymentFromTime,
             DateofFinalVedictPaymentToTime:fetchHeaderdataFinalVedict.PaymentToTime == null ? 0 : fetchHeaderdataFinalVedict.PaymentToTime,
             //END


             //Recovery

             RecoverAmount: fetchHeaderdataFinalVedict.RecoverAmount == null ? 0 : fetchHeaderdataFinalVedict.RecoverAmount,
             RecoveryResponsiblePerson: fetchHeaderdataFinalVedict.RecoveryResponsiblePerson == null ? 0 : fetchHeaderdataFinalVedict.RecoveryResponsiblePerson,
            //  Paymenttomadeinfavourof: fetchHeaderdataFinalVedict.Paymenttomadeinfavourof == null ? 0 : fetchHeaderdataFinalVedict.Paymenttomadeinfavourof,
            RecoveryRemarks: fetchHeaderdataFinalVedict.RecoveryRemarks == null ? 0 : fetchHeaderdataFinalVedict.RecoveryRemarks,
            DateofFinalVedictRecoveryToTime:fetchHeaderdataFinalVedict.RecoveryToTime == null ? 0 : fetchHeaderdataFinalVedict.RecoveryToTime,
            DateofFinalVedictRecoveryFromTime:fetchHeaderdataFinalVedict.RecoveryFromTime == null ? 0 : fetchHeaderdataFinalVedict.RecoveryFromTime,
             //END


              //Comply with Compliance

              TypeofCompliance: fetchHeaderdataFinalVedict.TypeofCompliance == null ? 0 : fetchHeaderdataFinalVedict.TypeofCompliance,
              ComplianceResponsiblePerson: fetchHeaderdataFinalVedict.ComplianceResponsiblePerson == null ? 0 : fetchHeaderdataFinalVedict.ComplianceResponsiblePerson,
             
              ComplianceRemarks: fetchHeaderdataFinalVedict.ComplianceRemarks == null ? 0 : fetchHeaderdataFinalVedict.ComplianceRemarks,
              DateofFinalVedictComplianceFromTime:fetchHeaderdataFinalVedict.ComplianceFromTime == null ? 0 : fetchHeaderdataFinalVedict.ComplianceFromTime,
              DateofFinalVedictComplianceToTime:fetchHeaderdataFinalVedict.ComplianceToTime == null ? 0 : fetchHeaderdataFinalVedict.ComplianceToTime,
              //END
          }
          
          )
          
          ;

        }
      }
      );
  }



  goBack() {
    window.history.back();
  }
}